<template>
    <div class="container mt-5">
        <div class="row justify-content-left mt-5">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <h3 class="mb-5">SignUp</h3>
                        <b-alert variant="danger" v-if="error" show>{{error}}</b-alert>
                        <b-form @submit="signup">
                            <b-form-group label="Email address" label-for="signupEmail">
                                <b-form-input
                                    id="signupEmail"
                                    type="email"
                                    v-model="form.email"
                                    aria-describedby="signupEmailError"
                                    :state="errors.email ? false : null"
                                    required>
                                </b-form-input>
                                <b-form-invalid-feedback id="signupEmailError">{{ errors.email }}</b-form-invalid-feedback>
                            </b-form-group>
                            <div class="row">
                                <div class="col">
                                    <b-form-group label="First name" label-for="firstName">
                                        <b-form-input
                                            id="firstName"
                                            type="text"
                                            v-model="form.first_name"
                                            aria-describedby="firstNameError"
                                            :state="errors.first_name ? false : null"
                                            required>
                                        </b-form-input>
                                        <b-form-invalid-feedback id="firstNameError">{{ errors.first_name }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group label="Last name" label-for="lastName">
                                        <b-form-input
                                            id="lastName"
                                            type="text"
                                            v-model="form.last_name"
                                            aria-describedby="lastNameError"
                                            :state="errors.last_name ? false : null"
                                            required>
                                        </b-form-input>
                                        <b-form-invalid-feedback id="lastNameError">{{ errors.last_name }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>
                            <b-form-group label="Password" label-for="signupPassword">
                                <b-form-input
                                    id="signupPassword"
                                    type="password"
                                    v-model="form.password"
                                    aria-describedby="signupPasswordError"
                                    :state="errors.password ? false : null"
                                    required>
                                </b-form-input>
                                <b-form-invalid-feedback id="signupPasswordError">{{ errors.password }}</b-form-invalid-feedback>
                            </b-form-group>
                            <b-button type="submit" variant="success">Sign Up</b-button>
                        </b-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    email: '',
                    password: '',
                    first_name: '',
                    last_name: ''
                },
                error: null,
                errors: []
            }
        },
        methods: {
            signup(event) {
                event.preventDefault();
                this.error = null;
                this.errors = [];
                window.axios
                    .post('/auth/signup', this.form)
                    .then(() => {
                        this.$store.commit('changeCurrentEmail', this.form.email);
                        this.$router.push({name: 'signup.confirm'});
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.data.title) {
                                this.error = error.response.data.title;
                            }
                            if (error.response.data.violations) {
                                error.response.data.violations.forEach(elem => {
                                    this.errors[elem.propertyPath] = elem.title;
                                });
                            }
                        } else {
                            console.log(error.message);
                        }
                    });
            }
        }
    }
</script>
